/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// FIELD INFO : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	info: {
		display: 'block',
		color: theme.color.neutral.medium.swatch,
		fontSize: pxToEm(12),
		marginTop: pxToEm(5)
	}
});